export const waitForElement = async (
  selector: string,
  timeout = 5000
): Promise<Element> => {
  const start = Date.now();

  while (Date.now() - start < timeout) {
    const el = document.querySelector(selector);

    if (el) {
      return el;
    }

    await new Promise((r) => requestAnimationFrame(r));
  }

  throw new Error(
    `Элемент ${selector} не найден после ${timeout / 1000} секунд`
  );
};
